module.exports = __webpack_public_path__ + "media/wyposazenie/opis@2x-86674ade.png";